module.exports = __webpack_public_path__ + "img/图6.71a195ad.png";